export interface PathType {
  location: string;
  path: string[];
}

export const getPath = (location: string, path: string[]): PathType => {
  const home: PathType = {
    location,
    path
  };
  return home;
};
